<template>
  <div id="stepFive">
    <h3 v-if="isLoading">Getting your application...</h3>
    <b-form v-if="isLoaded">
      <div class="container">
        <div v-if="isValid&&!isOverWordCount" style="border: #FEE800 10px solid; background: white; color: black; margin-bottom: 2em;"> 
          <h3 style="color: red; display: inline;">Notice:</h3><h3 style="display: inline;"> Once you submit, you will no longer be able to edit or change your application.</h3>
        </div>
        <div v-else-if="!isValid" style="border: #FEE800 10px solid; background: white; color: black; margin-bottom: 2em;">
          <h3 style="margin-top: 8px">Whoops! It looks like there are some sections that still need to be filled out before your application is complete: </h3>
          <ul >
            <li style="font-size: 18px" v-for="invalid in invalidFields">{{ invalid }}</li>
          </ul>
        </div>
        <div v-else style="border: #FEE800 10px solid; background: white; color: black; margin-bottom: 2em;">
          <h3 style="margin-top: 8px">"So close! One or more of your essay responses exceeded the word limit. Please revise and shorten them to proceed with your submission </h3>
          <ul >
            <li style="font-size: 18px" v-for="invalid in overWordCount">{{ invalid }}</li>
          </ul>
        </div>
        <div>
        <h1>Almost there! You are one step away from completing your application.</h1>
<h2> What Happens After I Submit?</h2>
<p>We will review your responses and reach out to your references soon. If you applied for financial aid, any awarded funds will be communicated alongside your acceptance decision. As a reminder, those funds will be distributed after the conference takes place.</p>
<h2>When Will I Hear Back?</h2>
<p>The first group of accepted applicants will be notified in May 2026. In order to recieve your results as soon as possible, please take a moment to adjust your spam filter settings to ensure emails from the ‘siggraph.org’ domain are not sent to your junk folder.</p>
<h2>Find Us on Social Media:</h2>
<p>Excited about your application? Share your journey with us on social media! Use the hashtags #SIGGRAPH2026 and #ProudToBeSV to connect with our community and alumni on Facebook, Instagram and X. </p>
</div>      
  <b-form-group>
        <div class="row">
          <div class="col">
            <button type="submit" :disabled="disabled" class="btn left-arrow-btn-primary float-left" @click="previousStep"><div>Previous Step</div></button>
          </div>
          <div class="col">
            <button type="submit" :disabled="disabledFinish" class="btn arrow-btn-primary float-right" @click="nextStep"><div>Submit Application</div></button>
          </div>
        </div>
      </b-form-group>
      </div>
    </b-form>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import router from '@/router'

const generateVuexSetters = (fields) => {
  let computed = {}
  fields.forEach(field => {
    computed[field] = {
      get () {
        return this.$store.state.application.data[field]
      },
      set (value) {
        this.$store.commit('application/updateField', { name: field, value })
      }
    }
  })
  return computed
}

export default {
  name: 'AppStepFive',
  data () {
    return {
      disabled: false,
      acceptedPrivacy: false,
      otherCommentsWordCount: '300 words remaining',
      otherCommentsWordLimitClass: 'under-limit',
      mediaReleaseAgreement: false
    }
  },
  computed: {
    ...mapGetters('application', ['isValid', 'invalidFields', 'isOverWordCount', 'overWordCount']),
    ...mapState('application', ['isLoaded', 'isLoading']),
    ...mapState(['applicationTlEndDate', 'applicationEndDate']),
    ...generateVuexSetters([
      'otherComments'
    ]),
    disabledFinish: function () {
      return !this.isValid || this.isOverWordCount
    }
  },
  methods: {
    wordCount (field, limit) {
      let words = this[field].trim().split(/\s+/)
      let wordCount = (words.length === 1 && words[0] === '') ? 0 : words.length
      let remaining = limit - wordCount
      this[field + 'WordCount'] = (remaining < 0) ? (remaining * -1).toString() + ' words over the limit, you will not be able to submit your application' : remaining.toString() + ' words remaining'
      this[field + 'WordLimitClass'] = (remaining < 0) ? 'over-limit' : 'under-limit'
    },
    formattedDate: function (date) {
      return moment(date).tz('UTC').format('D MMMM YYYY')
    },
    nextStep (e) {
      e.preventDefault()
      this.disabled = true
      router.push('/dashboard')
      // if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
      //   router.push('/dashboard')
      // } else {
      //   this.$store.dispatch('application/finish').then(() => {
      //     this.disabled = false
      //   })
      // }
    },
    previousStep (e) {
      e.preventDefault()
      this.disabled = true
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        // this.$store.commit('application/updateStep', 1)
        router.push({ name: 'stepOne' })
        // this.$store.dispatch('application/save').then(() => {
        //   router.push({ name: 'stepOne' })
        //   this.disabled = false
        // }).catch(err => {
        //   console.log(err.message)
        //   this.disabled = false
        // })
      }
    }
  },
  created: function () {
    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load').then(() => {
        if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
          this.$store.commit('application/disableTeamLeader')
        }
        if (this.$store.state.application.completed) {
          router.push('/dashboard')
        } else if (this.$store.state.application.isNew) {
          this.$store.dispatch('application/save')
        }
      })
    }
    if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
      this.$store.commit('application/disableTeamLeader')
    }
    if (this.$store.state.application.completed) {
      router.push('/dashboard')
    }
  },
  mounted: function () {
    this.wordCount('otherComments', 100)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/application/StepFive.vue